import axios from 'axios';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';


export default {
    init() {
        // JavaScript to be fired on the product page

        $('[data-toggle="tooltip"]').tooltip({trigger: 'manual'});

        /**************************************************/
        // product slider
        /**************************************************/

        const $productImagesSlider = $('.product-images-slider');

        $productImagesSlider.slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 768, // --breakpoint-md
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });

        this.InitSlickLightbox();

        /**************************************************/
        // color change
        /**************************************************/

        const $selectColor = $('#colors');
        const $DLids = $('#DL_product_ids');
        const $DLtotalValue = $('#DL_total_value');
        const $DLscript = $('#DL_script');

        $selectColor.on('change', (e) => {
            e.preventDefault();

            const color = $(e.currentTarget).val();
            $('[data-color]').removeClass('animate-in').removeClass('in');
            const $colorQty = $('[data-color="'+ color +'"]');

            const $currentColor = $('.colors-qty[data-color="'+ color +'"]');

            const colorName = $currentColor.data('color-name');
            const productId = $currentColor.data('product-id');
            const price = $currentColor.data('price');
            const category = $currentColor.data('category');
            const name = $currentColor.data('name');
            const brand = $currentColor.data('brand');

            $colorQty.addClass('animate-in');
            setTimeout( () => {
                $colorQty.addClass('in');
                $($colorQty[0]).slick('setPosition');
            }, 300);

            //data layers
            $DLids.html(productId + '-' + color);
            $DLtotalValue.html(price);
            $DLscript.html('var DL_product = {"ids":["'+productId + '-' + color+'"]};');

            // Tracking e-commerce - Product
            if(window.GOOGLE && window.GOOGLE.ga) {
                ga('create', window.GOOGLE.ga);
                ga('require', 'ec');


                ga('ec:addProduct', {
                    'id': ''+productId + '-' + color+'',
                    'name': name,
                    'category': category,
                    'brand': brand,
                    'variant': colorName,
                });

                ga('ec:setAction', 'detail');
                ga('send', 'pageview');
            }

            try {
              if(this.inIframe()) {
                parent.$('body').trigger('iframeContentResize', [$('body').outerHeight()]);
              }
            } catch (e) {}

        });

        /**************************************************/
        // product add
        /**************************************************/

        const $productForm = $('#product-form');
        const $btnSubmit = $('button.black');
        const $productSelectQty = $('select[name^="simple-product"]');

        let formIsSubmitting = false;
        $productForm.on('submit', e => {
            e.preventDefault();

            if(formIsSubmitting) {
                return;
            }

            let $productSelects = $('.colors-qty.animate-in.in').find('select');
            let products = [];

            for(let i = 0; i < $productSelects.length; i++) {
                let $currentSelect = $($productSelects[i]);

                if( $currentSelect.val() > 0) {
                    let productId = $currentSelect.attr('name').replace('simple-product-','');
                    products.push({ id: productId, qty: $currentSelect.val()});
                }
            }

            if(products.length == 0) {
                $btnSubmit.attr('data-original-title', window.CART.tooltip_noqty);
                $btnSubmit.tooltip("show");
                setTimeout(() => {
                    $btnSubmit.tooltip("hide");
                }, 8000);
                return;
            }

            $btnSubmit.attr('disabled',true);

            formIsSubmitting = true;

            axios.post(window.CART.add, products)
            .then(function (response) {

                if (response.status == 200 && response.statusText == 'OK') {
                    let products = response.data.products;
                    for (let i = 0; i < products.length; i++) {
                        $('#simple-product-'+products[i].id+' option').each( opt => {

                            if(opt > products[i].remainings) {
                                $('#simple-product-'+products[i].id+' option[value="'+opt+'"]').remove();
                            }

                            if(products[i].remainings <= 0) {
                                let $parentCol = $('#simple-product-'+products[i].id).parents('.col');
                                $parentCol.find('.form-group').remove();
                                $parentCol.append('<p class="na">'+window.CART.tooltip_na+'</p>');
                            }
                        });
                    }

                    $btnSubmit.attr('data-original-title', window.CART.tooltip_added);
                    $btnSubmit.tooltip("show");
                    setTimeout(() => {
                        $btnSubmit.tooltip("hide");
                    }, 8000);
                }

            })
            .catch(function (error) {
                console.log(error);
            })
            .then(() => {
                $btnSubmit.attr('disabled',false);
                formIsSubmitting = false;

                $(window).trigger('doUpdateCartContent');
                $productSelectQty.val(0);

            });
        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init function


    },

    inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    },
    
    InitSlickLightbox() {
        const $slicks = $('.product-images-slider');

        $slicks.each(function() {
            const $slick = $(this);
            const $images = $slick.find('.zoom-it');

            const lightbox = new PhotoSwipeLightbox({
                gallery: $slick[0], // Passa l'elemento DOM direttamente anziché il selettore CSS
                children: $images.toArray(), // Converte gli oggetti jQuery in un array di elementi DOM
                pswpModule: () => import('photoswipe/dist/photoswipe.esm.js'),
            });

            lightbox.init();
        });
    }

};
